import React, {Component} from 'react';
import {Tabs, Alert} from 'antd';
import Constants from '../../../commons/Constants';
import AlertConfigurationServiceMessage from './AlertConfigurationServiceMessage.js';
import AlertConfigurationServiceQuery from './AlertConfigurationServiceQuery.js';

class AlertConfigurationServiceDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saData: [],
            saDetail: {},
            threshholdList: [],
            showServiceAlert: ''
        };
    }

    componentDidMount() {
        var saData = this.props.saData;
        var showServiceAlert = this.props.showServiceAlert;
        this.loadData(saData, showServiceAlert);
    }

    componentWillReceiveProps(nextProps) {
        var saData = nextProps.saData;
        var showServiceAlert = nextProps.showServiceAlert;
        this.loadData(saData, showServiceAlert);
    }

    loadData = (saData, showServiceAlert) => {
        var saDetail = {
            index: '',
            queryTitle: '',
            queryTimerInfo: '0',
            queryTimeRange: '0',
            searchSize: '0',
            alertType: '0',
            alertTimeout: '0',
            threshhold: []
        };
        var threshholdList = [];
        for (var i = 0; i < saData.length; i++) {
            if (saData[i].index === showServiceAlert) {
                saDetail = JSON.parse(JSON.stringify(saData[i]));
                threshholdList = JSON.parse(JSON.stringify(saData[i].threshhold));
                break;
            }
        }

        this.setState({
            saDetail: saDetail,
            threshholdList: threshholdList,
            saData: saData,
            showServiceAlert: showServiceAlert
        });
    }

    render() {
        const saData = this.state.saData;
        const saDetail = this.state.saDetail;
        const threshholdList = this.state.threshholdList;

        return (
            <div className="page-system-usage-detail page-service-alert">
                <div>
                    <div className="panel-body page-detail-title">
                        <div className="form-group">
                            <i className="page-detail-graphic graphic-alert-detail"></i>
                            <b className="tenant-name">{this.state.showServiceAlert}</b>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <Alert style={{display: this.state.status === Constants.STATUS.error ? 'block' : 'none'}}
                               message={this.state.errorMessage} type="error" showIcon/>
                    </div>
                    <div>
                        <Tabs type="card">
                            <Tabs.TabPane tab={<span>Query Parameter</span>} key="1">
                                <AlertConfigurationServiceQuery saData={saData} saDetail={saDetail} onSuccess={this.props.onSuccess}/>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={<span>Alert Definition</span>} key="2">
                                <AlertConfigurationServiceMessage saData={saData} showServiceAlert={this.state.showServiceAlert} threshholdList={threshholdList} onSuccess={this.props.onSuccess}/>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
                <div className="page-close" onClick={this.props.close}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
            </div>
        );
    }
}
export default AlertConfigurationServiceDetail;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationServiceDetail.js